import { Fragment, type ReactNode } from "react";

export interface ScreenerQuestion {
  id: number;
  label: ReactNode;
  sublabels?: string[];
}

// Used when the user is a patient (second-person)
export const PATIENT_SCREENER_QUESTIONS: ScreenerQuestion[] = [
  {
    id: 1,
    label: (
      <Fragment>
        In the past <strong>30 days</strong>, have you been hospitalized for mental health
        treatment?
      </Fragment>
    ),
  },
  {
    id: 2,
    label: (
      <Fragment>
        In the past <strong>30 days</strong>, have you had an{" "}
        <strong>active eating disorder</strong>?
      </Fragment>
    ),
  },
  {
    id: 3,
    label: (
      <Fragment>
        Have you been told you have a <strong>serious mental illness</strong>, such as schizophrenia
        or bipolar disorder?
      </Fragment>
    ),
  },
  {
    id: 4,
    label: (
      <Fragment>
        Are you currently taking <strong>long-acting injectable medications</strong>, such as
        Abilify Maintena, Invega Sustena, Haloperidol decanoate, or similar medications?
      </Fragment>
    ),
  },
  {
    id: 5,
    label: (
      <Fragment>
        Are you currently taking medications for <strong>opioid use treatment</strong>, such as
        Buprenorphine, Methadone, Naltrexone, Vivitrol, or similar medications?
      </Fragment>
    ),
  },
  {
    id: 6,
    label: (
      <Fragment>
        Are you currently taking, or hoping to be prescribed, any of the following?
      </Fragment>
    ),
    sublabels: [
      "Stimulants (like Adderall or Ritalin)",
      "Anxiety medications (like Xanax, Ativan, or Klonopin)",
      "Sleep medications (like Ambien or Lunesta)",
    ],
  },
];

// Used when the user is a patient navigator, referrer, or any non-patient role (third-person)
export const NAVIGATOR_SCREENER_QUESTIONS: ScreenerQuestion[] = [
  {
    id: 1,
    label: (
      <Fragment>
        In the past <strong>30 days</strong>, has the patient been hospitalized for mental health
        treatment?
      </Fragment>
    ),
  },
  {
    id: 2,
    label: (
      <Fragment>
        In the past <strong>30 days</strong>, has the patient had an{" "}
        <strong>active eating disorder</strong>?
      </Fragment>
    ),
  },
  {
    id: 3,
    label: (
      <Fragment>
        Has the patient been told they have a <strong>serious mental illness</strong>, such as
        schizophrenia or bipolar disorder?
      </Fragment>
    ),
  },
  {
    id: 4,
    label: (
      <Fragment>
        Is the patient currently taking <strong>long-acting injectable medications</strong>, such as
        Abilify Maintena, Invega Sustena, Haloperidol decanoate, or similar medications?
      </Fragment>
    ),
  },
  {
    id: 5,
    label: (
      <Fragment>
        Is the patient currently taking medications for <strong>opioid use treatment</strong>, such
        as Buprenorphine, Methadone, Naltrexone, Vivitrol, or similar medications?
      </Fragment>
    ),
  },
  {
    id: 6,
    label: (
      <Fragment>
        Is the patient currently taking, or hoping to be prescribed, any of the following?
      </Fragment>
    ),
    sublabels: [
      "Stimulants (like Adderall or Ritalin)",
      "Anxiety medications (like Xanax, Ativan, or Klonopin)",
      "Sleep medications (like Ambien or Lunesta)",
    ],
  },
];
